import React, { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { FloatingWhatsApp } from "@/components/layout/FloatingWhatsApp";
import { AnnouncementBar } from "@/components/layout/AnnouncementBar";
import { LeadPopup } from "@/components/layout/LeadPopup";

// Scroll to top on route change (and to #hash targets when present).
const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
};

export const Layout = () => {
  return (
    <div className="App min-h-screen flex flex-col bg-[var(--et-bg)]">
      <ScrollManager />
      <AnnouncementBar />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <LeadPopup />
    </div>
  );
};
